const pub = { kind: 'public' };
const session = { kind: 'session' };
const svc = (...anyOf) => ({ kind: 'service', anyOf });
const r = (method, path, access, response, extra = {}) => ({ method, path, access, response, ...extra });
const json = { body: 'json' };
export const API_ROUTES = {
    // Auth and branches (unified-access.md section 3)
    authLaunch: r('POST', '/auth/launch', pub, 'json', json),
    authMe: r('GET', '/auth/me', session, 'json'),
    authLogout: r('POST', '/auth/logout', pub, 'empty'),
    branches: r('GET', '/branches', session, 'json'),
    // Users and groups (as in Customers)
    usersList: r('GET', '/users', svc('USER_LIST'), 'json'),
    usersEmployeeLookup: r('GET', '/users/employee-lookup', svc('USER_CREATE'), 'json'),
    usersGet: r('GET', '/users/:id', svc('USER_VIEW'), 'json'),
    usersCreate: r('POST', '/users', svc('USER_CREATE'), 'json', json),
    usersUpdate: r('PATCH', '/users/:id', svc('USER_UPDATE'), 'json', json),
    usersChangeStatus: r('PUT', '/users/:id/status', svc('USER_CHANGE_STATUS'), 'json', json),
    usersResetPassword: r('POST', '/users/:id/reset-password', svc('USER_RESET_PASSWORD'), 'json'),
    usersDelete: r('DELETE', '/users/:id', svc('USER_DELETE'), 'json'),
    groupsList: r('GET', '/groups', svc('GROUP_LIST'), 'json'),
    servicesTree: r('GET', '/services', svc('GROUP_LIST'), 'json'),
    groupsGet: r('GET', '/groups/:id', svc('GROUP_VIEW'), 'json'),
    groupsCreate: r('POST', '/groups', svc('GROUP_CREATE'), 'json', json),
    groupsUpdate: r('PATCH', '/groups/:id', svc('GROUP_UPDATE'), 'json', json),
    groupsChangeStatus: r('PUT', '/groups/:id/status', svc('GROUP_CHANGE_STATUS'), 'json', json),
    groupsSetServices: r('PUT', '/groups/:id/services', svc('GROUP_SERVICE_MANAGE'), 'json', json),
    groupsDelete: r('DELETE', '/groups/:id', svc('GROUP_DELETE'), 'json'),
    // Overview (debts.md section 5)
    overview: r('GET', '/overview', svc('DASHBOARD_VIEW'), 'json'),
    overviewMovements: r('GET', '/overview/movements', svc('DASHBOARD_VIEW'), 'json'),
    overviewMovementsExport: r('GET', '/overview/movements/export', svc('MOVEMENT_EXPORT'), 'file'),
    // Debtors (عملاء الذمم, debts.md section 6) and the customer statement (section 7.2)
    debtorsList: r('GET', '/debtors', svc('ACCOUNT_LIST'), 'json'),
    debtorsExport: r('GET', '/debtors/export', svc('ACCOUNT_EXPORT'), 'file'),
    debtorsGet: r('GET', '/debtors/:id', svc('ACCOUNT_VIEW'), 'json'),
    debtorsCreate: r('POST', '/debtors', svc('ACCOUNT_CREATE'), 'json', json),
    debtorsUpdate: r('PATCH', '/debtors/:id', svc('ACCOUNT_UPDATE'), 'json', json),
    debtorsAddAccount: r('POST', '/debtors/:id/accounts', svc('ACCOUNT_CREATE'), 'json', json),
    // إعادة التحقق (debts.md section 21; customers.md section 10.4).
    debtorsReverifyPhone: r('POST', '/debtors/:id/reverify-phone', svc('ACCOUNT_UPDATE'), 'json', {
        ...json,
        idempotent: true,
    }),
    // نقل الحسابات إلى العميل المسجل (debts.md section 22.4).
    debtorsMerge: r('POST', '/debtors/:id/merge', svc('ACCOUNT_UPDATE'), 'json', {
        ...json,
        idempotent: true,
    }),
    debtorsStatement: r('GET', '/debtors/:id/statement', svc('ACCOUNT_VIEW'), 'json'),
    debtorsStatementExport: r('GET', '/debtors/:id/statement/export', svc('MOVEMENT_EXPORT'), 'file'),
    // Accounts (debts.md section 6.4) and the account statement (section 7.1)
    accountsGet: r('GET', '/accounts/:id', svc('ACCOUNT_VIEW'), 'json'),
    accountsUpdate: r('PATCH', '/accounts/:id', svc('ACCOUNT_UPDATE'), 'json', json),
    accountsDelete: r('DELETE', '/accounts/:id', svc('ACCOUNT_DELETE'), 'empty'),
    accountsStatement: r('GET', '/accounts/:id/statement', svc('ACCOUNT_VIEW'), 'json'),
    accountsStatementExport: r('GET', '/accounts/:id/statement/export', svc('MOVEMENT_EXPORT'), 'file'),
    accountsLaterMovements: r('GET', '/accounts/:id/later-movements', svc('MOVEMENT_CREATE', 'MOVEMENT_UPDATE'), 'json'),
    // Movements (debts.md section 8)
    movementsCreate: r('POST', '/accounts/:id/movements', svc('MOVEMENT_CREATE'), 'json', {
        ...json,
        idempotent: true,
    }),
    movementsGet: r('GET', '/movements/:id', svc('ACCOUNT_VIEW'), 'json'),
    movementsUpdate: r('PATCH', '/movements/:id', svc('MOVEMENT_UPDATE'), 'json', json),
    movementsDelete: r('DELETE', '/movements/:id', svc('MOVEMENT_DELETE'), 'empty'),
    // WhatsApp messages (debts.md section 9)
    messagesGet: r('GET', '/messages/:id', svc('ACCOUNT_VIEW'), 'json'),
    messagesRetry: r('POST', '/messages/:id/retry', svc('MESSAGE_RETRY'), 'json'),
    // Reports (debts.md section 12)
    reportsEmployees: r('GET', '/reports/employees', svc('REPORT_VIEW'), 'json'),
    reportsPeriodMovements: r('GET', '/reports/period-movements', svc('REPORT_VIEW'), 'json'),
    reportsPeriodMovementsExport: r('GET', '/reports/period-movements/export', svc('REPORT_EXPORT'), 'file'),
    reportsCustomerBalances: r('GET', '/reports/customer-balances', svc('REPORT_VIEW'), 'json'),
    reportsCustomerBalancesExport: r('GET', '/reports/customer-balances/export', svc('REPORT_EXPORT'), 'file'),
    // WhatsApp phone verification through Customers (debts.md section 21)
    phoneVerificationsRequest: r('POST', '/phone-verifications', svc('ACCOUNT_CREATE', 'ACCOUNT_UPDATE'), 'json', json),
    phoneVerificationsResend: r('POST', '/phone-verifications/:id/resend', svc('ACCOUNT_CREATE', 'ACCOUNT_UPDATE'), 'json'),
    phoneVerificationsVerify: r('POST', '/phone-verifications/:id/verify', svc('ACCOUNT_CREATE', 'ACCOUNT_UPDATE'), 'json', json),
    phoneVerificationsGet: r('GET', '/phone-verifications/:id', svc('ACCOUNT_CREATE', 'ACCOUNT_UPDATE'), 'json'),
    // إعدادات الذمم (debts.md section 21)
    settingsGet: r('GET', '/settings', svc('SETTINGS_VIEW'), 'json'),
    settingsUpdate: r('PATCH', '/settings', svc('SETTINGS_UPDATE'), 'json', json),
    // Trash (debts.md section 8.3)
    trashList: r('GET', '/trash', svc('TRASH_LIST'), 'json'),
    trashRestoreMovement: r('POST', '/trash/movements/:id/restore', svc('TRASH_RESTORE'), 'json'),
    trashRestoreAccount: r('POST', '/trash/accounts/:id/restore', svc('TRASH_RESTORE'), 'json'),
};
/** Replaces `:param` segments; values are URI-encoded. */
export function buildApiPath(path, params = {}) {
    return path.replace(/:([A-Za-z]+)/g, (_match, name) => {
        const value = params[name];
        if (value === undefined)
            throw new Error(`missing path parameter ${name}`);
        return encodeURIComponent(value);
    });
}
//# sourceMappingURL=routes.js.map